import { TextField } from "@mui/material";
import { Alert, Button, Form } from "antd";
import { Link } from "react-router";
import { RoutePaths } from "../../../views/routes";
import Password from "../../Components/Password";
import RememberMe from "../../Components/Switch";

export interface LoginModel {
  email: string;
  password: string;
  remember: boolean;
}

interface LoginFormProps {
  onFinish: (data: LoginModel) => void;
  formError: string | undefined;
  isLoading: boolean;
}

export default function LoginForm({
  onFinish,
  formError,
  isLoading,
}: LoginFormProps) {
  return (
    <Form
      name="login"
      className="max-w-lg"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      disabled={isLoading}
    >
      {formError !== undefined && (
        <Alert
          message={formError}
          type="error"
          showIcon
          style={{ marginBottom: "20px" }}
        />
      )}
      <Form.Item
        className=""
        name="email"
        rules={[
          { type: "email", message: "Please input a valid email" },
          { required: true, message: "Please input your email!" },
        ]}
      >
        <TextField label="Email" variant="outlined" fullWidth />
      </Form.Item>
      <Form.Item
        className=""
        name="password"
        rules={[{ required: true, message: "Please input your password!" }]}
      >
        {/* @ts-expect-error ignoring lack of onChange value */}
        <Password />
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          shape="round"
          size={"large"}
          block
          htmlType="submit"
          loading={isLoading}
        >
          Log in
        </Button>
      </Form.Item>

      <Form.Item name="remember">
        {/* @ts-expect-error ignoring lack of onChange value */}
        <RememberMe />
      </Form.Item>

      <Form.Item>
        <Link to={RoutePaths.remindPassword} viewTransition>
          Forgot your password?
        </Link>
      </Form.Item>

      <span>
        By signing up you agree to Wishlist&nbsp;
        <Link to={RoutePaths.termsOfUse} viewTransition>
          Terms of Use
        </Link>{" "}
        and{" "}
        <Link to={RoutePaths.privacyPolicy} viewTransition>
          Privacy Policy
        </Link>
      </span>
    </Form>
  );
}
